import { Card, CardBody, Skeleton } from '@vnetwork/ui/primitives';
import { Stat, StatGroup } from '@vnetwork/ui/data';
import {
  dashboardCategoryTotal,
  dashboardServicesTotal,
  useOpsDashboard,
} from '@/api/operations-org-hooks';

/**
 * Dashboard-level stat band — 6 KPI cards from /internal/ops/dashboard.
 * Always reflects full system state (not filtered).
 */
export function OpsDashboardStatBand() {
  const { data, isLoading } = useOpsDashboard();

  const stats = [
    {
      label: 'Total services',
      value: dashboardServicesTotal(data?.by_category),
      dotColor: 'var(--vn-primary-solid)',
    },
    {
      label: 'CDN',
      value: dashboardCategoryTotal(data?.by_category, 'cdn'),
      dotColor: 'var(--vn-info-solid)',
    },
    {
      label: 'WAAP',
      value: dashboardCategoryTotal(data?.by_category, 'waap'),
      dotColor: 'var(--vn-warning-solid)',
    },
    {
      label: 'Compute',
      value: dashboardCategoryTotal(data?.by_category, 'compute'),
      dotColor: 'var(--vn-success-solid)',
    },
    {
      label: 'Active orgs',
      value: data?.total_orgs ?? 0,
      dotColor: 'var(--vn-primary-solid)',
    },
    {
      label: 'Total domains',
      value: data?.total_domains ?? 0,
      dotColor: 'var(--vn-info-solid)',
    },
  ];

  return (
    <Card flat>
      <CardBody>
        {isLoading ? (
          <StatGroup columns={6}>
            {stats.map((s) => (
              <Skeleton key={s.label} style={{ height: 56 }} />
            ))}
          </StatGroup>
        ) : (
          <StatGroup columns={6}>
            {stats.map((s) => (
              <Stat
                key={s.label}
                label={s.label}
                dotColor={s.dotColor}
                value={s.value.toLocaleString('en-US')}
              />
            ))}
          </StatGroup>
        )}
      </CardBody>
    </Card>
  );
}
